window.$ = window.jQuery = require( "jquery" );
require('./lib/jquery.fancybox.min.js')
require('./lib/simplebar')
require('./lib/select2.full.js')
require('./lib/jquery-ui.min.js')
require('./lib/jquery.maskedinput.js')
require('./lib/jquery.validate.js')

require('./scripts/common')
require('./scripts/timer')
require('./scripts/configurator.js')
require('./scripts/sliders.js')
// require('./scripts/map.js')
require('./filters');

require('./initPopups');
require('./includes/formHandlers')

